export default {
  methods: {
    inputNumberValidate(value) {
      if (value)
        return value.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    inputNumberValidateSteps(value, min, max) {
      if (value) {
        if (value >= max) value = max
        return value.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      } else {
        value = min
        return value.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      }
    }
  }
}